module.exports = __webpack_public_path__ + "media/assets/images/live_curtain-dbe1377d52a78ff41e0cdc8b49aaa449.png";